module.exports = __webpack_public_path__ + "static/media/xIconBlack.659c68e8.svg";